import { render } from "./OrgStructure.vue?vue&type=template&id=a525b582&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=a525b582&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=a525b582&lang=scss"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a525b582"]])

export default __exports__